import Typography from "@mui/material/Typography";
import {Grid, Stack} from "@mui/material";
import ErrorHandlingForm from "../../../components/formValidation/ErrorHandlingForm";
import {useState} from "react";
import CustomTextField from "../../../components/formValidation/CustomTextField";
import CustomTinyMCE from "../../../components/formValidation/CustomTinyMce";
import {validateMaxLength, validateRequired} from "../../../components/formValidation/validators";

const NewOrderColleague = ({reference, data, setData}) => {
    const [errors, setErrors] = useState({
        colleague_new_order_email_title: false,
        colleague_new_order_email: false,
        colleague_new_order_sms: false
    })

    const validators = {
        colleague_new_order_email_title: [validateRequired, value => validateMaxLength(255, value)],
        colleague_new_order_email: [validateRequired],
        colleague_new_order_sms: [value => validateMaxLength(255, value)]
    }

    return <ErrorHandlingForm
        data={data}
        setData={setData}
        reference={reference}
        errors={errors}
        setErrors={setErrors}
        validators={validators}
    >
        <Grid container spacing={3} marginTop={2}>
            <Grid item xs={12} md={6}>
                <Stack spacing={2}>
                    <Typography variant='caption' color='primary.main'>
                        e-mail címsor (max. 255 karakter)
                    </Typography>
                    <CustomTextField
                        data={data}
                        setData={setData}
                        errors={errors}
                        setErrors={setErrors}
                        validators={validators}
                        name='colleague_new_order_email_title'
                        variant='standard'
                    />
                    <Typography variant='caption' color='primary.main'>
                        e-mail szövege
                    </Typography>
                    <CustomTinyMCE
                        data={data}
                        setData={setData}
                        errors={errors}
                        setErrors={setErrors}
                        validators={validators}
                        name='colleague_new_order_email'
                    />
                </Stack>
            </Grid>
            <Grid item xs={12} md={6}>
                <Stack spacing={2}>
                    <Typography variant='caption' color='primary.main'>
                        sms címsor (max. 255 karakter)
                    </Typography>
                    <CustomTextField
                        data={data}
                        setData={setData}
                        errors={errors}
                        setErrors={setErrors}
                        validators={validators}
                        name='colleague_new_order_sms'
                        variant='standard'
                        multiline
                        rows={5}
                    />
                </Stack>
            </Grid>
        </Grid>
    </ErrorHandlingForm>
}

export default NewOrderColleague